// LoanImportance.jsx
import React from "react";
import "./LoanImportance.css";

const reasons = [
  {
    title: "Preserve Your Savings",
    description:
      "Instead of depleting your entire nest egg to buy property outright, a home loan lets you keep your savings invested for emergencies or other goals.",
  },
  {
    title: "Leverage Your Purchase",
    description:
      "With just a small down payment, you can control a much larger asset—the bank finances the rest—amplifying your investment potential.",
  },
  {
    title: "Tax Benefits",
    description:
      "Home loan interest payments and principal repayments can qualify for significant deductions under income‐tax laws, reducing your overall tax liability.",
  },
  {
    title: "Flexible Repayment Tenure",
    description:
      "Choose tenures from 5 to 30 years (depending on the bank) to fit EMI obligations comfortably within your monthly budget.",
  },
  {
    title: "Build Credit Score",
    description:
      "Timely EMI payments demonstrate financial discipline to credit bureaus, boosting your credit score and easing access to other loans in future.",
  },
  {
    title: "Hedge Against Inflation",
    description:
      "Real estate historically outpaces inflation; locking in today’s interest rate on a long‐term loan means you repay in “cheaper” currency over time.",
  },
];

export default function LoanImportance() {
  return (
    <div className="loan-container">
      <h2 className="loan-heading">Why a Bank Loan Makes Property Buying Easier</h2>
      <p className="loan-intro">
        Purchasing a home is one of the biggest financial steps many of us take. A bank loan can turn this dream into reality
        by spreading the cost, offering tax breaks, and more. Here’s why:
      </p>
      <div className="loan-grid">
        {reasons.map((item, idx) => (
          <div key={idx} className="loan-card">
            <h3 className="loan-card-title">{item.title}</h3>
            <p className="loan-card-desc">{item.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

